const getItemListData = data => {
  if (data && data.getItemList && data.getItemList.listItems) return data.getItemList.listItems;
  return [];
};
export default getItemListData;
//# sourceMappingURL=get-item-list-data.js.map